import React from 'react';
import './ShowMoreAccounts.scss';

export interface ShowMoreAccountsProps {
  numberOfFunds: number;
  onShowClick(): void;
  isCollege: boolean;
}
const ShowMoreAccounts: React.VFC<ShowMoreAccountsProps> = ({
  numberOfFunds,
  onShowClick,
  isCollege,
}) => (
  <div
    className="show-more-accounts e2e-show-more-accounts college-branded-fund-list-quick-action-bar"
    id="show-more-funds"
    onClick={onShowClick}
  >
    <span className="show-more-accounts-description">
      View all {isCollege ? 'portfolios' : 'funds'}
    </span>
    (showing 1 of {numberOfFunds})
  </div>
);

export default ShowMoreAccounts;
